import React from "react";
import { Transition } from "@headlessui/react";
import ChevronLeftIcon from "@heroicons/react/24/solid/ChevronLeftIcon";

import cx from "@hsl/core/utils/cx";

import Button from "../Button";
import CustomScroller from "../CustomScroller";

export interface Props extends React.PropsWithChildren {
    className?: string;
    containerClassName?: string;
    isOpen?: boolean;
    toggleIsOpen?(): void;
}

const Sidebar = ({
    isOpen = true,
    className,
    containerClassName,
    children,
    toggleIsOpen,
}: Props) => {
    return (
        <div
            className={cx(
                "absolute bottom-0 top-0 z-30 lg:relative lg:-left-2",
                containerClassName,
            )}
        >
            <Transition
                show={isOpen}
                className="sm:duration-400 z-10 block h-full transform transition duration-200 ease-in-out"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
            >
                <div className="h-full max-w-full bg-white pb-4">
                    <CustomScroller
                        className={cx(
                            "sticky top-0 h-screen max-h-screen w-max overflow-x-hidden bg-white pr-8",
                            className,
                        )}
                    >
                        <Button
                            className="group absolute right-0 top-0 border-none border-gray-100 bg-blue-50 shadow-none hover:bg-blue-100 lg:hidden"
                            color="white"
                            icon={
                                <ChevronLeftIcon className="group-hover:text-dark-blue ml-0 mr-0 h-6 w-6 transform transition group-hover:-translate-x-1" />
                            }
                            onClick={toggleIsOpen}
                        />
                        {children}
                    </CustomScroller>
                </div>
            </Transition>
        </div>
    );
};

export default Sidebar;
